import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.slice";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

import { observable, action } from 'mobx';
import { StoreExt } from '@utils/reactExt';
import { LOCALSTORAGE_KEYS } from '@constants/index';
export var GlobalStore = (_class = (_temp = class GlobalStore extends StoreExt {
  constructor() {
    super(...arguments);

    _initializerDefineProperty(this, "sideBarCollapsed", _descriptor, this);

    _initializerDefineProperty(this, "sideBarTheme", _descriptor2, this);

    _initializerDefineProperty(this, "navOpenKeys", _descriptor3, this);

    _initializerDefineProperty(this, "toggleSideBarCollapsed", _descriptor4, this);

    _initializerDefineProperty(this, "changeSiderTheme", _descriptor5, this);

    _initializerDefineProperty(this, "setOpenKeys", _descriptor6, this);
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "sideBarCollapsed", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return localStorage.getItem(LOCALSTORAGE_KEYS.SIDE_BAR_COLLAPSED) === '1';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sideBarTheme", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return localStorage.getItem(LOCALSTORAGE_KEYS.SIDE_BAR_THEME) || 'light';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "navOpenKeys", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return JSON.parse(localStorage.getItem(LOCALSTORAGE_KEYS.NAV_OPEN_KEYS)) || [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "toggleSideBarCollapsed", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return () => {
      this.sideBarCollapsed = !this.sideBarCollapsed;
      localStorage.setItem(LOCALSTORAGE_KEYS.SIDE_BAR_COLLAPSED, this.sideBarCollapsed ? '1' : '0');
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "changeSiderTheme", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return theme => {
      this.sideBarTheme = theme;
      localStorage.setItem(LOCALSTORAGE_KEYS.SIDE_BAR_THEME, theme);
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "setOpenKeys", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return openKeys => {
      this.navOpenKeys = openKeys;
      localStorage.setItem(LOCALSTORAGE_KEYS.NAV_OPEN_KEYS, JSON.stringify(openKeys));
    };
  }
})), _class);
export default new GlobalStore();